<template>
  <div>
    <div class="floorFour" :style="{ backgroundImage: 'url(' + bakcImg + ')' }">
      <div class="title_box">
        <div class="en" v-if="activefalg === 2 && safe_three_mode === 2">
          TECHNICAL ADVANTAGES
        </div>
        <div
          class="en"
          v-if="
            (safe_three_mode === 1 && activefalg === 0) ||
            (activefalg === 1 && safe_three_mode === 1) ||
            (activefalg === 2 && safe_three_mode === 1) ||
            (safe_three_mode === 2 && activefalg === 0) ||
            (safe_three_mode === 2 && activefalg === 1)
          "
        >
          DETAILED INTERPRETATION
        </div>
        <div class="zh" v-if="activefalg === 2 && safe_three_mode === 2">
          技术优势
        </div>
        <div class="zh" v-if="activefalg === 2 && safe_three_mode === 1">
          <!-- 抗菌率＞99.9% -->
          技术优势
        </div>
        <div
          class="zh"
          v-if="
            (safe_three_mode === 1 && activefalg === 0) ||
            (activefalg === 1 && safe_three_mode === 1) ||
            (safe_three_mode === 2 && activefalg === 0) ||
            (safe_three_mode === 2 && activefalg === 1)
          "
        >
          {{ zh_title }}
        </div>
        <div class="line"></div>
      </div>
      <div class="one_and_tow" v-if="activefalg === 0">
        <div class="img_box">
          <img :src="safe_one_image" alt="" />
        </div>
        <div class="back_box"></div>
      </div>
      <div class="infomation_box" v-if="activefalg === 0">
        {{ safe_one_text }}
      </div>
      <div class="one_and_tow" v-if="activefalg === 1">
        <div class="img_box">
          <img :src="safe_two_image" alt="" />
        </div>
        <div class="back_box"></div>
      </div>
      <div class="infomation_box" v-if="activefalg === 1">
        {{ safe_two_text }}
      </div>
      <div class="threed_box" v-if="activefalg === 2 && safe_three_mode === 1">
        <div class="prev_box" @mouseenter="prevEnter" @mouseleave="prevLeave">
          <img
            v-if="swiperArr.length > 3"
            class="img_cover"
            :src="prev_image"
            alt=""
          />
        </div>
        <div class="swiper_box">
          <swiper
            :options="swiperOption"
            class="myswiper"
            ref="mySwiper"
            v-if="swiperArr.length"
          >
            <swiper-slide
              v-for="(item, index) in swiperArr"
              :key="index"
              style="width: 30%"
            >
              <div class="swiperSlide" @click="preview(index)">
                <img :src="item" class="img_cover" alt="" />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="next_box" @mouseenter="nextEnter" @mouseleave="nextLeave">
          <img
            v-if="swiperArr.length > 3"
            :src="next_image"
            alt=""
            class="img_cover"
          />
        </div>
      </div>
      <div
        class="infomation_box"
        v-if="activefalg === 2 && safe_three_mode === 1"
      >
        {{ safe_three_text }}
      </div>
      <div class="table_box" v-if="activefalg === 2 && safe_three_mode === 2">
        <table width="100%">
          <tr>
            <th>{{ th.one }}</th>
            <th>{{ th.two }}</th>
            <th>{{ th.three }}</th>
          </tr>
          <tr v-for="(item, index) in tr" :key="index">
            <td>{{ item.one }}</td>
            <td>{{ item.two }}</td>
            <td>{{ item.three }}</td>
          </tr>
        </table>
      </div>

      <div class="three_box">
        <div
          :class="activefalg === index ? 'item1' : 'item'"
          v-for="(item, index) in threeArr"
          :key="index"
          @click="select(index)"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="preview_box" @click="close" v-if="previewflag">
        <div class="preview_center" @click.stop>
          <el-image
            :src="previewImg"
            style="height: 100%; width: 100%"
            fit="fit"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      prev_image: require("../../assets/indexImg/transparent_prev_img.png"),
      next_image: require("../../assets/indexImg/transparent_next_img.png"),
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 40,
        navigation: {
          nextEl: ".next_box",
          prevEl: ".prev_box",
        },
        on: {},
      },
      zh_title: '地板界的“抗造”硬汉',
      advantages: true,
      threeArr: [
        {
          text: "产品功能",
        },
        {
          text: "科技原理",
        },
        {
          text: "技术优势",
        },
      ],
      swiperArr: [],
      activefalg: 0,
      previewImg: "",
      previewflag: false,
      bakcImg: "",
      safe_three_mode: 0,
      safe_one_image: "",
      safe_two_image: "",
      th: {},
      safe_one_text: "",
      safe_two_text: "",
      safe_three_text: "",
      tr: [],
    };
  },
  methods: {
    prevLeave() {
      this.prev_image = require("../../assets/indexImg/transparent_prev_img.png");
    },
    prevEnter() {
      this.prev_image = require("../../assets/indexImg/blue_prev_img.png");
    },
    nextLeave() {
      this.next_image = require("../../assets/indexImg/transparent_next_img.png");
    },
    nextEnter() {
      this.next_image = require("../../assets/indexImg/blue_next_img.png");
    },
    select(index) {
      this.activefalg = index;
      // console.log(index,this.safe_three_mode)
    },
    preview(i) {
      this.previewImg = this.swiperArr[i];
      // console.log(this.previewImg);
      this.previewflag = true;
    },
    close() {
      this.previewflag = false;
    },
  },
  mounted() {
    if (this.$route.query.id) {
      var text_id = this.$route.query.id;
      if (text_id == 0) {
        this.zh_title = "高科技环保地板·绿色健康零甲醛";
        this.threeArr[1].text="科技材料"
      }
      if (text_id == 1) {
        this.zh_title = "抗菌无惧挑战";
      }
      if (text_id == 2) {
        this.zh_title = "爱她就给她一个温暖的家";
      }
      if (text_id == 3) {
        this.zh_title = "防火安全利器";
      }
    }
    var index = Number(this.$route.query.id);
  var indata = Number(this.$route.query.in);
  if (index==0) {
     var obj =
      this.$store.state.floorData[index]  ||
      JSON.parse(localStorage.getItem("floorData"))[index] ;
    this.bakcImg = obj.children[indata].safe_background;
    this.safe_three_mode = obj.children[indata].safe_three_mode;
    this.safe_one_image = obj.children[indata].safe_one_image;
    this.safe_two_image = obj.children[indata].safe_two_image;
    this.th = obj.children[indata].safe_three_table.tr;
    this.tr = obj.children[indata].safe_three_table.td;
    this.safe_one_text = obj.children[indata].safe_one_text;
    this.safe_two_text = obj.children[indata].safe_two_text;
    this.safe_three_text = obj.children[indata].safe_three_text;
    this.swiperArr = obj.children[indata].safe_three_image;
  }else{
     var obj =
      this.$store.state.floorData[index] ||
      JSON.parse(localStorage.getItem("floorData"))[index];
    this.bakcImg = obj.safe_background;
    this.safe_three_mode = obj.safe_three_mode;
    this.safe_one_image = obj.safe_one_image;
    this.safe_two_image = obj.safe_two_image;
    this.th = obj.safe_three_table.tr;
    this.tr = obj.safe_three_table.td;
    this.safe_one_text = obj.safe_one_text;
    this.safe_two_text = obj.safe_two_text;
    this.safe_three_text = obj.safe_three_text;
    this.swiperArr = obj.safe_three_image;
  }

   
  },
  computed: {
    floorData() {
      return this.$store.state.floorData;
    },
  },
  watch: {
    floorData(val) {
      console.log(val);
    },
  },
};
</script>

<style scoped lang='scss'>
.floorFour {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  .title_box {
    width: 100vw;
    height: 9.3vh;
    padding-top: 16vh;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      line-height: 2.8vh;
      text-align: center;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      margin-top: -2vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .one_and_tow {
    // width: 1000px;
    width: 52.08vw;
    // height: 470px;
    height: 47vh;
    position: relative;
    margin: 0 auto;
    // margin-top: 36px;
    margin-top: 3.6vh;
    .back_box {
      // width: 990px;
      width: 51.56vw;
      // height: 460px;
      height: 46vh;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
      background: #0fffff;
    }
    .img_box {
      width: 51.56vw;
      // height: 460px;
      height: 46vh;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      img {
        width: 100% !important;
        height: 100% !important;
        // object-fit: contain;
      }
    }
  }
  .threed_box {
    width: 87.77vw;
    // height: 470px;
    height: 47vh;
    margin: 0 auto;
    // margin-top: 36px;
    margin-top: 3.6vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .swiper_box {
      width: 67.77vw;
      height: 100%;
      .myswiper {
        width: 100%;
        height: 100%;
        .swiperSlide {
          width: 100%;
          // height: 470px;
          height: 47vh;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
    .prev_box {
      width: 92px;
      height: 92px;
    }
    .prev_box:focus {
      outline: none;
    }
    .next_box:focus {
      outline: none;
    }
    .next_box {
      width: 92px;
      height: 92px;
    }
  }
  .table_box {
    // height: 370px;
    height: 37vh;
    width: 1200px;
    // margin: 121px auto 115px auto;
    margin: 12.1vh auto 11.5vh auto;
    table {
      border-collapse: collapse;
      tr {
        th {
          // height: 50px;
          width: 15.62vw;
          height: 5vh;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          // line-height: 50px;
          line-height: 5vh;
          color: #ffffff;
          background: rgba(15, 225, 225, 0.2);
        }
        th:first-child {
          width: 31.25vw;
        }
        td {
          // height: 80px;
          height: 8vh;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 80px;
          line-height: 8vh;
          color: #ffffff;
          text-align: center;
          border: 1px solid #ffffff;
        }
      }
    }
  }
  .infomation_box {
    width: 1000px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    // line-height: 28px;
    line-height: 2.8vh;
    color: #ffffff;
    text-align: center;
    // margin: 40px auto 40px auto;
    margin: 4vh auto 4vh auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .three_box {
    width: 764px;
    // height: 37px;
    height: 3.7vh;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .item {
      width: 200px;
      text-align: center;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 28px;
      line-height: 2.8vh;
      color: #ffffff;
      border-bottom: 1px solid #ffffff;
      transition: all 0.5s;
    }
    .item1 {
      width: 200px;
      text-align: center;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 28px;
      line-height: 2.8vh;
      color: #0fffff;
      border-bottom: 1px solid #0fffff;
      transition: all 0.5s;
      cursor: url("../../assets/cursor.png"), none;
    }
    .item:hover {
      color: #0fffff;
      border-bottom: 1px solid #0fffff;
      transition: all 0.5s;
      cursor: url("../../assets/cursor.png"), none;
    }
  }
  .preview_box {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    .preview_center {
      // width: 644px;
      width: 33.55vw;
      // height: 800px;
      height: 80vh;
    }
  }
}
</style>